import { publicRequest } from "./publicInviteApi.js";

/**
 * P167 frontend for the public Partner Invite Card endpoints
 * (GET /api/public/partner-invite-card, POST .../apply).
 *
 * Reuses publicInviteApi's request seam rather than the shared apiClient, for
 * exactly the reason that module documents: apiRequest() attaches an
 * Authorization header whenever a session token happens to exist in the tab -
 * which it very often does here, because the sending Super Agent previews their
 * own letter while still signed in to the backoffice. These routes are
 * unauthenticated by design.
 *
 * A separate module even so: worker, employer and partner links must never be
 * able to resolve to each other's form, and one shared "invite" module is
 * exactly how that eventually happens.
 */
export function getPublicPartnerInviteCard(inviteCode, options) {
  return publicRequest(`/public/partner-invite-card?invite=${encodeURIComponent(inviteCode)}`, {
    ...options,
    method: "GET",
  });
}

export function submitPartnerApplication(payload, options) {
  return publicRequest("/public/partner-invite-card/apply", {
    ...options,
    method: "POST",
    body: JSON.stringify(payload),
  });
}
